import * as API from '@/services/api'

export async function fetchTranslations(language, textType, filter, interactionToken) {
    const filterQuery = filter ? `&filter=${filter}` : ''
    const interactionQuery = interactionToken ? `&interactionToken=${interactionToken}` : ''

    const response = await API.get(`/api/i18ns?language=${language}&textTypeParameter=${textType}${filterQuery}${interactionQuery}`)
    return response.data
}

export async function fetchLocales() {
    const response = await API.get(`/api/system/config`)
    return response.data.locales;
}
